<template>
  <div
    class="t-grid__item"
    :class="{'t-grid__item--avtive': isSelected}"
    :style="{
      background: backgroundColor,
      border: `1px solid ${backgroundColor}`
    }"
    @click="$emit('click')"
  >
    {{ txt }}
    <div class="t-grid__flag" v-if="isSelected">
      <i class="el-icon-check t-grid__icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TGridItem',
  props: {
    txt: String,
    isSelected: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#F9F9F9'
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>



// WEBPACK FOOTER //
// src/components/TGridItem/index.vue